'use strict';

module Patersons {

    export class RecaptchaVerifyService extends BaseService {
        // Confirm the response token received from Google Recaptcha is valid
        // This is posted to a server side controller so as not to expose the Recaptcha secret
        siteVerify(response: string): ng.IHttpPromise<any> {
            let rv = new RecaptchaVerify();
            rv.remoteip = '';
            rv.response = response;
            var absoluteUrl = this.baseUrl + "/dataService/api/recaptcha";

            return this.post("/dataService/api/recaptcha", rv);             
        };
    }
}